export const navigation = [
  {
    name: "工作平台",
    eName: "Home",
    icon: "fa fa-dashboard",
    active: false,
    subOption: false,
    path: "/module/home",
    index: "dashboard",
  },
  {
    name: "审批管理",
    eName: "Approval",
    icon: "fa ion-ios-paper",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "1",
    children: [
      {
        name: "审批流管理",
        eName: "Workflow",
        active: false,
        subOption: false,
        path: "/module/procedure",
        index: "1-1",
      },
      {
        name: "我的审批",
        eName: "My",
        active: false,
        subOption: true,
        arrow: false,
        index: "1-2",
        children: [
          {
            name: "待办",
            eName: "To-do",
            active: false,
            subOption: false,
            index: "1-2-1",
            path: "/module/examine1",
          },
          {
            name: "已办",
            eName: "Processed",
            active: false,
            subOption: false,
            index: "1-2-2",
            path: "/module/examine2",
          },
          {
            name: "被退回",
            active: false,
            subOption: false,
            eName: "Rejected",
            index: "1-2-3",
            path: "/module/examine3",
          },
          {
            name: "办结",
            eName: "Finished",
            active: false,
            subOption: false,
            index: "1-2-4",
            path: "/module/examine4",
          },
        ],
      },
      {
        name: "待我阅知",
        eName: "View",
        path: "/module/consult",
        active: false,
        subOption: false,
        index: "1-3",
      },
    ],
  },
  {
    name: "组织机构",
    eName: "Organization",
    icon: "fa ion-android-funnel",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "2",
    children: [
      {
        name: "机构",
        eName: "Organization",
        active: false,
        subOption: true,
        arrow: false,
        index: "2-1",
        children: [
          {
            name: "当地雇主",
            eName: "Local Employer",
            active: false,
            subOption: false,
            index: "2-2",
            path: "/module/Sponsor",
          },
          {
            name: "用工形式",
            eName: "Employment Form",
            active: false,
            subOption: false,
            index: "2-3",
            path: "/module/employmentForm",
          },
          {
            name: "成本归集",
            eName: "Cost Accumulation",
            active: false,
            subOption: false,
            index: "2-4",
            path: "/module/CostAccumulation",
          },
        ],
      },
      {
        name: "项目",
        eName: "Project",
        active: false,
        subOption: false,
        index: "2-2",
        path: "/module/project",
      },
      {
        name: "单位",
        eName: "Unit",
        active: false,
        subOption: true,
        arrow: false,
        index: "2-3",
        children: [
          {
            name: "单位",
            eName: "Unit",
            active: false,
            subOption: false,
            index: "2-3-1",
            path: "/module/company",
          },
          {
            name: "干系人管理",
            eName: "Stakeholder",
            active: false,
            subOption: false,
            index: "2-3-2",
            path: "/module/companyStakeholderType",
          },
        ],
      },
      {
        name: "部门",
        eName: "Department",
        active: false,
        subOption: true,
        arrow: false,
        index: "2-8",
        children: [
          {
            name: "部门",
            eName: "Department",
            active: false,
            subOption: false,
            index: "2-8-1",
            path: "/module/department",
          },
          {
            name: "部门属性",
            eName: "Department Tyoe",
            active: false,
            subOption: false,
            index: "2-8-2",
            path: "/module/departmentType",
          },
        ],
      },
      {
        name: "岗位",
        eName: "Job Profession",
        active: false,
        subOption: true,
        arrow: false,
        index: "2-4",
        children: [
          {
            name: "岗位性质",
            eName: "Job Nature",
            active: false,
            subOption: false,
            index: "2-4-1",
            path: "/module/jobNature",
          },
          {
            name: "岗位类别",
            eName: "Job Category",
            active: false,
            subOption: false,
            index: "2-4-2",
            path: "/module/jobCategory",
          },
          {
            name: "岗位子类别",
            eName: "Job Sub Category",
            active: false,
            subOption: false,
            index: "2-4-3",
            path: "/module/positionSubCategory",
          },
          {
            name: "岗位目录",
            eName: "Job Profession",
            active: false,
            subOption: false,
            index: "2-4-4",
            path: "/module/position",
          },
          {
            name: "岗位沙化分类",
            eName: "Saudization Category",
            active: false,
            subOption: false,
            index: "2-4-5",
            path: "/module/saudizationGroup",
          },
          {
            name: "岗位层级",
            eName: "Job Level",
            active: false,
            subOption: false,
            index: "2-4-6",
            path: "/module/positionLevel",
          },
        ],
      },
      {
        name: "组织关系",
        eName: "Organization Structure",
        active: false,
        subOption: false,
        index: "2-5",
        path: "/module/organization",
      },
      {
        name: "成本中心",
        eName: "Cost Center",
        active: false,
        subOption: false,
        index: "2-6",
        path: "/module/costCenter",
      },
    ],
  },
  {
    name: "人员管理",
    eName: "Employee",
    icon: "fa ion-android-people",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "3",
    children: [
      {
        name: "基础信息",
        eName: "Basic",
        active: false,
        subOption: false,
        index: "3-1",
        path: "/module/userList",
      },
      {
        name: "教育背景",
        eName: "Education",
        active: false,
        subOption: true,
        arrow: false,
        index: "3-2",
        children: [
          {
            name: "专业",
            eName: "Major",
            active: false,
            subOption: false,
            index: "3-2-1",
            path: "/module/major",
          },
          {
            name: "学位",
            eName: "Degree",
            active: false,
            subOption: false,
            index: "3-2-2",
            path: "/module/degree",
          },
          {
            name: "学历",
            eName: "Education",
            active: false,
            subOption: false,
            index: "3-2-3",
            path: "/module/education",
          },
          {
            name: "毕业院校",
            eName: "School",
            active: false,
            subOption: false,
            index: "3-2-4",
            path: "/module/school",
          },
          {
            name: "教育背景",
            active: false,
            subOption: false,
            index: "3-2-5",
            path: "/module/employeeEducationBackground",
            eName: "Education Background",
          },
        ],
      },
      {
        name: "工作信息",
        eName: "Work Information",
        active: false,
        subOption: false,
        index: "3-3",
        path: "/module/JobInfo",
      },
      {
        name: "资格能力",
        eName: "Qualification & Ability",
        active: false,
        subOption: true,
        arrow: false,
        index: "3-5",

        children: [
          {
            name: "专业技术资格名称",
            eName: "Professional Title",
            active: false,
            subOption: false,
            index: "3-5-3",
            path: "/module/ProfessionalTitle",
          },
          {
            name: "资格能力",
            eName: "Qualification & Ability",
            active: false,
            subOption: false,
            index: "3-5-1",
            path: "/module/QualificationsandCompetenceInfo",
          },
          {
            name: "资质信息",
            eName: "Qualification Information",
            eName: "Degree",
            active: false,
            subOption: false,
            index: "3-2-2",
            path: "/module/employeeQualificationsandCompetence",
          },
        ],
      },
      {
        name: "银行账户",
        eName: "Bank Account",
        active: false,
        subOption: false,
        index: "3-6",
        path: "/module/bankAccount",
      },
      {
        name: "外事信息",
        eName: "Foreign Affairs Info",
        active: false,
        subOption: false,
        index: "3-7",
        path: "/module/foreignAffairInfos",
      },
      {
        name: "薪酬信息",
        eName: "Salary Standard",
        active: false,
        subOption: false,
        index: "3-8",
        path: "/module/CompensationInfo",
      },
      {
        name: "奖惩情况",
        eName: "Reward & Penalty",
        active: false,
        subOption: true,
        arrow: false,
        index: "3-9",
        children: [
          {
            name: "不良人员",
            eName: "Block List",
            active: false,
            subOption: false,
            index: "3-9-1",
            path: "/module/blacklist",
          },
          {
            name: "奖惩情况",
            eName: "Record",
            active: false,
            subOption: false,
            index: "3-9-2",
            path: "/module/employeeRewardandPenaltyRecord",
          },
        ],
      },
      {
        name: "员工入职信息录入审批",
        eName: "Employee Enrollment Registration",
        active: false,
        subOption: false,
        index: "3-15",
        path: "/module/employeeOnboardingInformation",
      },
      {
        name: "人员信息修改",
        eName: "Personnel information modification",
        active: false,
        subOption: true,
        arrow: false,
        index: "3-10",
        path: "/module/changeApplication",
        children: [
          {
            name: "人员信息修改审批",
            eName: "Info Change Application",
            active: false,
            subOption: false,
            index: "3-10-1",
            path: "/module/changeApplication",
          },
          {
            name: "人员信息修改申请审批",
            eName: "Personnel Information Modification Application Approval",
            active: false,
            subOption: false,
            index: "3-10-2",
            path: "/module/employeeInfoChangeRequest",
          },
        ],
      },

      {
        name: "本单位工作年限",
        eName: "Overseas Work Years",
        active: false,
        subOption: false,
        index: "3-12",
        path: "/module/LengthofService",
      },
      {
        name: "组合查询",
        eName: "Combined Query",
        active: false,
        subOption: false,
        index: "3-13",
        path: "/pages/User/UserCombineQuery.aspx",
      },
      {
        name: "历史信息",
        eName: "Historical Info",
        active: false,
        subOption: true,
        arrow: false,
        index: "3-14",
        children: [
          {
            name: "历史信息",
            eName: "Historical of Field",
            active: false,
            subOption: false,
            index: "3-14-1",
            path: "/pages/User/HistoryLog.aspx",
          },
          {
            name: "人员备份",
            eName: "Backup",
            active: false,
            subOption: false,
            index: "3-14-2",
            path: "/module/PersonnelBackup",
          },
        ],
      },
      {
        name: "员工工作经历",
        eName: "Work Experience",
        active: false,
        subOption: false,
        index: "3-15",
        path: "/module/EmployeeWorkExperience",
      },
      {
        name: "员工履历表",
        eName: "Employee Resume",
        active: false,
        subOption: false,
        index: "3-11",
        path: "/module/employeeCareerRecord",
      },
    ],
  },
  {
    name: "人力资源",
    eName: "Human Resource",
    icon: "fa ion-ios-paper",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "4",
    children: [
      {
        name: "人力计划",
        eName: "Manpower Planning",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-1",
        children: [
          {
            name: "年度人力资源负荷计划审批",
            eName: "Annual Human Resources Load Plan Approval",
            active: false,
            subOption: false,
            index: "4-1-1",
          },
          {
            name: "三个月人力资源滚动计划审批",
            eName: "Approval of the Three-Month Rolling Human Resources Plan",
            active: false,
            subOption: false,
            index: "4-1-2",
          },
        ],
      },
      {
        name: "人力调配",
        eName: "Human Resource Allocation",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-2",
        children: [
          {
            name: "人力资源招聘审批",
            eName: "Human Resources Recruitment Approval",
            active: false,
            subOption: false,
            index: "4-2-1",
            path: "/module/manpower",
          },
          {
            name: "人力需求协调配置情况",
            eName: "Coordination and configuration of manpower demand",
            active: false,
            subOption: false,
            index: "4-2-2",
            path: "/module/manpowerRequestAccounting",
          },
          {
            name: "内部借工审批",
            eName: "Internal borrowing approval",
            active: false,
            subOption: false,
            index: "4-2-3",
            path: "/module/internalBorrowingAgreement",
          },
          {
            name: "内部借工费用分割审批",
            eName: "Approval of internal borrowing cost division",
            active: false,
            subOption: false,
            index: "4-2-4",
            path: "/module/internalBorrowingAgreementCost",
          },
          {
            name: "人员调转审批",
            eName: "Personnel transfer approval",
            active: false,
            subOption: false,
            index: "4-2-5",
            path: "/module/employeeInternalTransferOrderApplication",
          },
          {
            name: "人员调转台账",
            eName: "Personnel transfer ledger",
            active: false,
            subOption: false,
            index: "4-2-6",
            path: "/module/employeeInternalTransferOrderAccounting",
          },
          {
            name: "人员撤离审批",
            eName: "Personnel evacuation approval",
            active: false,
            subOption: false,
            index: "4-2-7",
            path: "/module/planeTicket",
          },
        ],
      },
      {
        name: "本土化用工",
        eName: "Localized employment",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-3",
        children: [
          {
            name: "沙特籍培训费用分割审批",
            eName:
              "Approval of Separation of Training Expenses for Saudi Nationals",
            active: false,
            subOption: false,
            index: "4-3-1",
            path: "/module/cost2",
          },
          {
            name: "沙化费用分割审批",
            eName: "Approval of desertification cost division",
            active: false,
            subOption: false,
            index: "4-3-2",
            path: "/module/cost1",
          },
          {
            name: "HRDF返还费用审批",
            eName: "HRDF refund expense approval",
            active: false,
            subOption: false,
            index: "4-3-3",
            path: "/module/cost3",
          },
        ],
      },

      {
        name: "当地外包",
        eName: "Local Outsourcing",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-4",
        children: [
          {
            name: "外包单位管理",
            eName: "Outsourcing unit management",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-4-1",
            children: [
              {
                name: "外包单位引入审批",
                eName: "Approval for the introduction of outsourcing units",
                active: false,
                subOption: false,
                index: "4-4-1-1",
                path: "/module/outsourcingApproval",
              },
              {
                name: "外包单位资源库",
                eName: "Outsourcing Unit Resource Library",
                active: false,
                subOption: false,
                index: "4-4-1-2",
                path: "/module/oufm",
              },
            ],
          },
          {
            name: "单价及PO管理",
            eName: "Unit price and PO management",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-4-2",
            children: [
              {
                name: "外包人员指导价审批",
                eName: "Outsourced personnel guide price approval",
                active: false,
                subOption: false,
                index: "4-4-2-1",
                path: "/module/oInformation",
              },
              {
                name: "外包单位订单审批",
                eName: "Approval of outsourcing unit orders",
                active: false,
                subOption: false,
                index: "4-4-2-2",
                path: "/module/ljsoo",
              },
              {
                name: "外包单位订单台账",
                eName: "Outsourcing Unit Order Ledger",
                active: false,
                subOption: false,
                index: "4-4-2-3",
                path: "/module/ljsoosjk",
              },
            ],
          },
          {
            name: "费用管理",
            eName: "Cost Management",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-4-3",
            children: [
              {
                name: "月度挂账",
                eName: "Monthly outstanding accounts",
                active: false,
                subOption: false,
                index: "4-4-3-1",
                path: "/module/monthlyCredit",
              },
              {
                name: "月度挂账审批",
                eName: "Monthly credit approval",
                active: false,
                subOption: false,
                index: "4-4-3-2",
                path: "/module/manpowerSupplierMonthlyCost",
              },
              {
                name: "外包单位费用台账",
                eName: "Outsourcing Unit Expense Ledger",
                active: false,
                subOption: false,
                index: "4-4-3-3",
                path: "/module/monthlyCreditManagement",
              },
              {
                name: "外包人员费用台账",
                eName: "Outsourced personnel expense ledger",
                active: false,
                subOption: false,
                index: "4-4-3-4",
                path: "/module/outsourcingFee",
              },
            ],
          },
        ],
      },
      {
        name: "培训开发",
        eName: "Training and Development",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-5",
        children: [
          {
            name: "年度培训班计划审批",
            eName: "Approval of Annual Training Course Plan",
            active: false,
            subOption: false,
            index: "4-5-1",
            path: "/module/trainingCourseApplication",
          },
          {
            name: "年度培训班台账",
            eName: "Annual Training Course Ledger",
            active: false,
            subOption: false,
            index: "4-5-2",
            path: "/module/trainingCourseAccounting",
          },
        ],
      },
      {
        name: "岗位变动",
        eName: "Position change",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-6",
        children: [
          {
            name: "员工岗位变动审批",
            eName: "Approval of Employee Position Changes",
            active: false,
            subOption: false,
            index: "4-6-1",
            path: "/module/positionAdjustmentApplicantion",
          },
          {
            name: "员工岗位变动管理",
            eName: "Employee Position Change Management",
            active: false,
            active: false,
            subOption: false,
            index: "4-6-2",
            path: "/module/positionAdjustmentApplicantionOffline",
          },
        ],
      },

      {
        name: "假勤管理",
        eName: "Leave Management",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-7",
        children: [
          {
            name: "病事假审批",
            eName: "Approval of sick leave",
            active: false,
            subOption: false,
            index: "4-7-1",
            path: "/module/leave",
          },
          {
            name: "福利假审批",
            eName: "Welfare leave approval",
            active: false,
            subOption: false,
            index: "4-7-2",
            path: "/module/leaveWelfare",
          },

          {
            name: "定期休假审批",
            eName: "Regular vacation approval",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-7-3",
            children: [
              {
                name: "定期休假审批",
                eName: "Regular vacation approval",
                active: false,
                subOption: false,
                index: "4-7-3-1",
                path: "/module/LeaveRegular",
              },
              {
                name: "定期休假规则",
                eName: "Regular vacation rules",
                active: false,
                subOption: false,
                index: "4-7-3-2",
                path: "/module/EmployeeLeavePolicy",
              },
            ],
          },

          {
            name: "加班审批",
            eName: "Overtime approval",
            active: false,
            subOption: false,
            index: "4-7-4",
            path: "/module/overtime",
          },
          {
            name: "员工休假台账",
            eName: "Employee Leave Ledger",
            active: false,
            subOption: false,
            index: "4-7-5",
            path: "/module/EmployeeLeaveAccounting",
          },
          {
            name: "员工年度考勤汇总表",
            eName: "Annual Attendance of Employees",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-7-6",
            children: [
              {
                name: "中国籍非直聘",
                eName: "Non direct employment of Chinese nationality",
                active: false,
                subOption: false,
                index: "4-7-6-1",
                path: "/module/chineseEmployeeAttendances",
              },
              {
                name: "中国籍直聘",
                eName: "Chinese direct employment",
                active: false,
                subOption: false,
                index: "4-7-6-2",
                path: "/module/chineseLocalEmployeeAttendance",
              },
              {
                name: "外籍",
                eName: "Foreign nationality",
                active: false,
                subOption: false,
                index: "4-7-6-3",
                path: "/module/foreignEmployeeAttendance",
              },
            ],
          },
        ],
      },

      {
        name: "薪资管理",
        eName: "Salary Management",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-8",
        children: [
          {
            name: "国内薪资计发",
            eName: "Domestic salary",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-8-1",
            children: [
              {
                name: "国内薪资计发",
                eName: "Domestic salary",
                active: false,
                subOption: false,
                index: "4-8-1-1",
                path: "/pages/NZGL/HomeSalaryBase.aspx",
              },
              {
                name: "国内奖金计发",
                eName: "Domestic bonuses",
                active: false,
                subOption: false,
                index: "4-8-1-2",
                path: "/pages/NZGL/HomeBonusBase.aspx",
              },
            ],
          },
          {
            name: "国外薪资计发",
            eName: "Foreign salary",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-8-2",
            children: [
              {
                name: "汇率设置",
                eName: "Exchange rate",
                active: false,
                subOption: false,
                index: "4-8-2-1",
                path: "/pages/NZGL/ExchangeRate.aspx",
              },
              {
                name: "中国籍非直聘薪资计算",
                eName:
                  "Salary calculation for non direct employment of Chinese nationals",
                active: false,
                subOption: false,
                index: "4-8-2-2",
                path: "/pages/NZGL/ChineseWagesReckon.aspx",
              },
              {
                name: "中国籍直聘薪资计算",
                eName:
                  "Salary calculation for direct employment of Chinese nationals",
                active: false,
                subOption: false,
                index: "4-8-2-3",
                path: "/pages/NZGL/ChineseWagesReckonZP.aspx",
              },
              {
                name: "外籍薪资计算",
                eName: "Foreign salary calculation",
                active: false,
                subOption: false,
                index: "4-8-2-4",
                path: "/pages/NZGL/ForeignerWagesReckon.aspx",
              },
              {
                name: "奖金计算",
                eName: "Bonus calculation",
                active: false,
                subOption: false,
                index: "4-8-2-5",
                path: "/pages/NZGL/BonusReckon.aspx",
              },
              {
                name: "个税计算",
                eName: "Individual income tax calculation",
                active: false,
                subOption: false,
                index: "4-8-2-6",
                path: "/pages/NZGL/ChineseIncomeTaxReckon.aspx",
              },
              {
                name: "分包单位中国籍薪资计算",
                eName:
                  "Salary calculation for Chinese nationals of subcontracting units",
                active: false,
                subOption: false,
                index: "4-8-2-7",
                path: "/pages/NZGL/SubWagesReckon.aspx",
              },
              {
                name: "分包单位外籍薪资计算",
                eName: "Salary calculation for foreign subcontractors",
                active: false,
                subOption: false,
                index: "4-8-2-8",
                path: "/pages/NZGL/ForeignerSubWagesReckon.aspx",
              },
              {
                name: "分包单位中国籍薪资计算New",
                eName:
                  "Salary calculation for Chinese nationals of subcontracting units New",
                active: false,
                subOption: false,
                index: "4-8-2-9",
                path: "/pages/NZGL/ChineseSalaryTableMain.aspx",
              },
              {
                name: "薪资发放(现金)",
                eName: "Salary payment (cash)",
                active: false,
                subOption: false,
                index: "4-8-2-10",
                path: "/pages/NZGL/CashPaymentBase.aspx",
              },
              {
                name: "薪资发放(打卡)",
                eName: "Salary payment (clock in)",
                active: false,
                subOption: false,
                index: "4-8-2-11",
                path: "/pages/NZGL/CardPayment.aspx",
              },
              {
                name: "暂存统计",
                eName: "Temporary storage statistics",
                active: false,
                subOption: false,
                index: "4-8-2-12",
                path: "/pages/NZGL/TransactionHistoryStatistics.aspx",
              },
              {
                name: "暂存日志",
                eName: "Temporary storage log",
                active: false,
                subOption: false,
                index: "4-8-2-13",
                path: "/pages/NZGL/TransactionHistoryLog.aspx",
              },
              {
                name: "年度工资表",
                eName: "Annual salary statement",
                active: false,
                subOption: false,
                index: "4-8-2-14",
                path: "/pages/NZGL/SalaryReport.aspx",
              },
            ],
          },
          {
            name: "收入统计",
            eName: "Income statistics",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-8-5",
            children: [
              {
                name: "中国籍",
                eName: "Chinese nationality",
                active: false,
                subOption: false,
                index: "4-8-5-1",
                path: "/pages/NZGL/ChineseIncomeDetails.aspx",
              },
              {
                name: "中国籍New",
                eName: "Chinese nationality New",
                active: false,
                subOption: false,
                index: "4-8-5-2",
                path: "/pages/NZGL/ChineseIncomeDetailsNew.aspx",
              },
              {
                name: "中国籍（直聘）",
                eName: "Chinese nationality (direct employment)",
                active: false,
                subOption: false,
                index: "4-8-5-3",
                path: "/pages/NZGL/ChineseIncomeDetailsZP.aspx",
              },
              {
                name: "外籍",
                eName: "Foreign nationality",
                active: false,
                subOption: false,
                index: "4-8-5-4",
                path: "/pages/NZGL/ForeignerIncomeDetails.aspx",
              },
            ],
          },
          {
            name: "EOSB费用计提审批",
            eName: "EOSB Cost",
            active: false,
            subOption: false,
            index: "4-8-6",
            path: "/module/EOSBCost",
          },
          {
            name: "人工成本稽核",
            eName: "Labor cost audit",
            active: false,
            subOption: false,
            index: "4-8-7",
            path: "/pages/NZGL/CostCheck.aspx",
          },
          {
            name: "薪资设置",
            eName: "Salary Setting",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-8-8",
            children: [
              {
                name: "薪资标准项设置",
                eName: "Salary standard item setting",
                active: false,
                subOption: false,
                index: "4-8-8-1",
                path: "/pages/NZGL/SalaryUserItems.aspx",
              },
              {
                name: "人员薪资标准设置",
                eName: "Personnel salary standard setting",
                active: false,
                subOption: false,
                index: "4-8-8-2",
                path: "/pages/NZGL/SalaryUserStandard.aspx",
              },
              {
                name: "员工薪资标准调整审批",
                eName: "Approval of Employee Salary Standard Adjustment",
                active: false,
                subOption: false,
                index: "4-8-8-3",
                path: "/module/employeeSalaryAdjustment",
              },
              {
                name: "自定义薪资表",
                eName: "Customize salary table",
                active: false,
                subOption: false,
                index: "4-8-8-4",
                path: "/pages/NZGL/SalaryItemTable.aspx",
              },
              {
                name: "关联中文薪资表",
                eName: "Associate Chinese salary table",
                active: false,
                subOption: false,
                index: "4-8-8-5",
                path: "/pages/NZGL/SalaryItemTableRelations.aspx",
              },
              {
                name: "关联英文薪资表",
                eName: "Associate English salary table",
                active: false,
                subOption: false,
                index: "4-8-8-6",
                path: "/pages/NZGL/SalaryItemTableRelations2.aspx",
              },
            ],
          },
        ],
      },
      {
        name: "劳动合同",
        eName: "Labor Contract",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-9",
        children: [
          {
            name: "电子合同注册审批",
            eName: "Approval of Electronic Contract Registration",
            active: false,
            subOption: false,
            index: "4-9-1",
          },
          {
            name: "员工合同台账",
            eName: "Employee Contract Ledger",
            active: false,
            subOption: false,
            index: "4-9-2",
            path: "/module/EmploymentContractAccounting",
          },
        ],
      },
      {
        name: "人事报表",
        eName: "Personnel Report",
        active: false,
        subOption: true,
        arrow: false,
        index: "4-10",
        children: [
          {
            name: "当地岗位外包/分包人数",
            eName: "Number of subcontractors",
            active: false,
            subOption: false,
            index: "4-10-1",
            path: "/pages/NZGL/LocalPosition.aspx",
          },

          {
            name: "HR周报",
            eName: "HR Weekly Report",
            active: false,
            subOption: true,
            arrow: false,
            index: "4-10-2",
            children: [
              {
                name: "人数统计报表",
                eName: "Number of people statistics report",
                active: false,
                subOption: false,
                index: "4-10-2-1",
                path: "/module/HRWeekly",
              },
              {
                name: "外部数据采集表",
                eName: "External Data Collection Table",
                active: false,
                subOption: false,
                index: "4-10-2-2",
                path: "/module/HRWeeklyExternal",
              },
            ],
          },
          {
            name: "人力负荷统计表",
            eName: "Labor Load Statistics Table",
            active: false,
            subOption: false,
            index: "4-10-3",
            path: "/pages/NZGL/HRReportMain.aspx",
          },
          {
            name: "境外机构人员统计表",
            eName: "Statistical Table of Personnel from Overseas Institutions",
            active: false,
            subOption: false,
            index: "4-10-4",
            path: "/pages/NZGL/HumanStatistics.aspx",
          },
        ],
      },
      {
        name: "人事仪表盘",
        eName: "Personnel Dashboard",
        active: false,
        subOption: false,
        index: "4-11",
        path: "/pages/NZGL/GlobalReport.aspx",
      },
    ],
  },
  {
    name: "外事业务",
    eName: "Foreign Affair",
    icon: "fa ion-android-globe",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "5",
    children: [
      {
        name: "公司",
        eName: "Company",
        active: false,
        subOption: false,
        index: "5--2",
        path: "/module/corporation",
      },
      {
        name: "政府平台",
        eName: "Government platform",
        active: false,
        subOption: false,
        index: "5--1",
        path: "/module/governmentPlatform",
      },
      {
        name: "保险公司",
        eName: "Insurance company",
        active: false,
        subOption: false,
        index: "5-0",
        path: "/module/insuranceCompany",
      },
      {
        name: "企业资质",
        eName: "Business Qualification",
        active: false,
        subOption: false,
        index: "5-1",
        path: "/module/orgQualification",
      },
      {
        name: "政务平台",
        eName: "Government service platform",
        active: false,
        subOption: false,
        index: "5-2",
        path: "/module/digitalGovernmentPlatform",
      },
      {
        name: "工作签证",
        eName: "Work visa",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-3",
        children: [
          {
            name: "工作签证指标使用计划审批",
            eName: "Usage plan",
            active: false,
            subOption: false,
            index: "5-3-1",
            path: "/module/workVisaApplication5",
          },
          {
            name: "工作签证指标购买审批",
            eName: "Buy",
            active: false,
            subOption: false,
            index: "5-3-2",
            path: "/module/workVisaApplication1",
          },
          {
            name: "工作签证指标授权审批",
            eName: "Authorization",
            active: false,
            subOption: false,
            index: "5-3-3",
            path: "/module/workVisaApplication2",
          },
          {
            name: "工作签证指标取消授权审批",
            eName: "Revoke authorization",
            active: false,
            subOption: false,
            index: "5-3-4",
            path: "/module/workVisaApplication3",
          },
          {
            name: "工作签证指标退还记录",
            eName: "Return Record",
            active: false,
            subOption: false,

            index: "5-3-5",
            path: "/module/workVisaApplication4",
          },
          {
            name: "工作签证指标变动明细",
            eName: "Change Details",
            active: false,
            subOption: false,

            index: "5-3-6",
            path: "/module/workVisaQuotaUsageRecords",
          },
          {
            name: "工作签证指标管理台账",
            eName: "Management ledger",
            active: false,
            subOption: false,

            index: "5-3-7",
            path: "/module/workVisaQuotas",
          },
          {
            name: "员工签证使用审批",
            eName: "Approval of Employee Visa Use",
            active: false,
            subOption: false,

            index: "5-3-8",
            path: "/module/visaApproval",
          },
          {
            name: "员工签证审批台账",
            eName: "Employee Visa Approval Ledger",
            active: false,
            subOption: false,

            index: "5-3-9",
            path: "/module/statisticalLedger",
          },
          // {
          //   name: "临时工作签证办理审批",
          //   active: false,
          //   subOption: true,
          //   arrow: false,
          //   index: "5-3-10",
          //   path: "/module/issueTemporaryWorkingVisa",
          // },
          {
            name: "临时工作签证延期审批",
            eName: "Temporary work visa extension approval",
            active: false,
            subOption: false,

            index: "5-3-11",
            path: "/module/temporaryWrokingVisaExtension",
          },
          // {
          //   name: "工作访签办理",
          //   active: false,
          //   subOption: true,
          //   arrow: false,
          //   index: "5-3-12",
          //   path: "/module/issueWorkingVisitVisa",
          // },
          // {
          //   name: "工作访签延期",
          //   active: false,
          //   subOption: true,
          //   arrow: false,
          //   index: "5-3-13",
          //   path: "/module/wrokingVisitVisaExtension",
          // },
        ],
      },
      {
        name: "暂住证",
        eName: "IQAMA",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-4",
        children: [
          {
            name: "暂住证办理审批",
            eName: "IQAMA Handle",
            active: false,
            subOption: false,

            index: "5-4-1",
            path: "/module/issueNewIqama",
          },
          {
            name: "暂住证延期审批",
            eName: "IQAMA postponement",
            active: false,
            subOption: false,

            index: "5-4-2",
            path: "/module/renewIqama",
          },
          {
            name: "暂住证注销审批",
            eName: "IQAMA Log out",
            active: false,
            subOption: false,

            index: "5-4-3",
            path: "/module/cancelIQAMA",
          },
          {
            name: "暂住证职位更改审批",
            eName: "IQAMA Job change",
            active: false,
            subOption: false,

            index: "5-4-4",
            path: "/module/changeIQAMAProfession",
          },
          {
            name: "暂住证信息管理",
            eName: "IQAMA Information Management",
            active: false,
            subOption: false,

            index: "5-4-5",
            path: "/module/IQAMA",
          },
        ],
      },
      {
        name: "出入境签证",
        eName: "Entry Exit Visa",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-5",
        children: [
          {
            name: "单次往返签证办理审批",
            eName: "Single round trip visa",
            active: false,
            subOption: false,

            index: "5-5-1",
            path: "/module/singleExitReentryVisa",
          },
          {
            name: "多次往返签证办理审批",
            eName: "Multiple entry visa",
            active: false,
            subOption: false,

            index: "5-5-2",
            path: "/module/multipleExitReentryVisa",
          },
          {
            name: "往返签证延期审批",
            eName: "Extension of round-trip visa",
            active: false,
            subOption: false,

            index: "5-5-3",
            path: "/module/extendExitReentryVisa",
          },
          {
            name: "往返签证注销审批",
            eName: "Cancellation of round-trip visa",
            active: false,
            subOption: false,

            index: "5-5-4",
            path: "/module/cancelExitReentry",
          },
          {
            name: "离境签证办理审批",
            eName: "Approval of Exit Visa Application",
            active: false,
            subOption: false,

            index: "5-5-5",
            path: "/module/issueExitVisa",
          },
          {
            name: "离境签证注销审批",
            eName: "Exit visa cancellation approval",
            active: false,
            subOption: false,

            index: "5-5-6",
            path: "/module/ccancelExitVisa",
          },
        ],
      },

      {
        name: "当地访问签证",
        eName: "Local Visit Visa",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-6",
        children: [
          {
            name: "访问签证邀请函审批",
            eName: "Approval of Visit Visa Invitation Letter",
            active: false,
            subOption: false,

            index: "5-6-1",
            path: "/module/invite",
          },
          {
            name: "家庭访签邀请函审批",
            eName: "Approval of Family Visit Invitation Letter",
            active: false,
            subOption: false,

            index: "5-6-2",
            path: "/module/visitInvitationLetter",
          },
          // {
          //   name: "商务访签办理审批",
          //   active: false,
          //   subOption: true,
          //   arrow: false,
          //   index: "5-6-3",
          //   path: "/module/issueBusniessVisitVisa",
          // },
          {
            name: "商务访签延期审批",
            eName: "Business visit visa extension approval",
            active: false,
            subOption: false,

            index: "5-6-4",
            path: "/module/busniessVisitVisaExtension",
          },
        ],
      },
      {
        name: "因公临时出境",
        eName: "Temporary departure for official business",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-7",
        children: [
          {
            name: "因公临时出境任务审批",
            eName: "Temporary departure for official business",
            active: false,
            subOption: false,

            index: "5-7-1",
            path: "/module/overseasMission",
          },
          {
            name: "任务批件信息管理",
            eName: "Task approval information management",
            active: false,
            subOption: false,

            index: "5-7-2",
            path: "/module/taskApprovalDocument",
          },
          {
            name: "第三国访问签证办理审批",
            eName: "Third country visitor visa",
            active: false,
            subOption: false,

            index: "5-7-3",
            path: "/module/thirdCountryVisaApplication",
          },
          {
            name: "因公临时出境出行情况",
            eName: "Temporary outbound travel for official purposes",
            active: false,
            subOption: false,

            index: "5-7-4",
            path: "/module/overseasWorksApplicationDetail",
          },
        ],
      },
      {
        name: "外国人访华业务",
        eName: "Foreigners visiting China for business purposes",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-8",
        children: [
          {
            name: "外国人访华业务审批",
            eName: "Foreigners visiting China for business purposes",
            active: false,
            subOption: false,
            index: "5-8-1",
            path: "/module/foreignVisitsToChina",
          },
        ],
      },
      {
        name: "签证信息管理",
        eName: "Visa Information Management",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-9",
        children: [
          {
            name: "工作签证状态跟踪",
            eName: "Work visa status tracking",
            active: false,
            subOption: false,

            index: "5-9-1",
            path: "/module/RecordforVisa",
          },
          {
            name: "往返签证状态跟踪",
            eName: "Tracking of round-trip visa status",
            active: false,
            subOption: true,
            arrow: false,
            index: "5-9-2",
            children: [
              {
                name: "单次往返签证",
                eName: "Single round trip visa",
                active: false,
                subOption: false,

                index: "5-9-2-1",
                path: "/module/VisaRecordofBusiness2",
              },
              {
                name: "多次往返签证",
                eName: "Multiple entry visa",
                active: false,
                subOption: false,

                index: "5-9-2-2",
                path: "/module/VisaRecordofBusiness3",
              },
              {
                name: "往返签证延期",
                eName: "Extension of round-trip visa",
                active: false,
                subOption: false,

                index: "5-9-2-3",
                path: "/module/VisaRecordofBusiness4",
              },
              {
                name: "离境签证",
                eName: "exit visa",
                active: false,
                subOption: false,

                index: "5-9-2-4",
                path: "/module/VisaRecordofBusiness5",
              },
            ],
          },
          {
            name: "访问签证状态跟踪",
            eName: "Visitor Visa Status Tracking",
            active: false,
            subOption: false,

            index: "5-9-3",
            path: "/module/RecordforVisa1",
          },
          {
            name: "第三国签证状态跟踪",
            eName: "Third country visa status tracking",
            active: false,
            subOption: false,

            index: "5-9-4",
            path: "/module/VisaRecordofBusiness1",
          },
          // {
          //   name: "签证预警",
          //   active: false,
          //   subOption: false,

          //   index: "5-9-5",
          //   path: "/module/visaWarning",
          // },
        ],
      },
      {
        name: "雇员转移",
        eName: "Employee Transfer",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-10",
        children: [
          {
            name: "雇员转保",
            eName: "Employee Reinsurance",
            active: false,
            subOption: false,

            index: "5-10-1",
            path: "/module/sponsorChange",
          },
        ],
      },
      {
        name: "当地医保",
        eName: "Local medical insurance",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-11",
        children: [
          {
            name: "医保等级标准",
            eName: "Medical insurance level standard",
            active: false,
            subOption: false,
            index: "5-11-1",
            path: "/module/employeeMedicalInsuranceClassLevel",
          },
          {
            name: "员工医保注册审批",
            eName: "Employee medical insurance registration approval",
            active: false,
            subOption: false,
            index: "5-11-2",
            path: "/module/employeeMedicalInsuranceRegistration",
          },
          {
            name: "员工医保等级变更审批",
            eName: "Change of employee medical insurance level",
            active: false,
            subOption: false,

            index: "5-11-3",
            path: "/module/employeeMedicalInsuranceAdjustmentmentApplication",
          },
          {
            name: "医保信息台账",
            eName: "Medical insurance information ledger",
            active: false,
            subOption: false,

            index: "5-11-7",
            path: "/module/employeeMedicalInsuranceRecords",
          },

          {
            name: "员工医保信息管理",
            eName: "Employee medical insurance information management",
            active: false,
            subOption: false,

            index: "5-11-4",
            path: "/module/employeeMedicalInsurance",
          },
          {
            name: "医保费用分割审批",
            eName: "Approval of medical insurance expense splitting",
            active: false,
            subOption: false,

            index: "5-11-5",
            path: "/module/SHICost",
          },
          // {
          //   name: "医保预警",
          //   eName: "Medical insurance warning",
          //   active: false,
          //   subOption: false,

          //   index: "5-11-6",
          //   path: "/pages/WSYW/STWarningInsurance.aspx",
          // },
        ],
      },
      {
        name: "当地社保",
        eName: "Local social security",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-12",
        children: [
          {
            name: "中国籍当地社保等级标准",
            eName: "Local social security level standards for Chinese citizens",
            active: false,
            subOption: false,
            index: "5-12-1",
            path: "/module/employeeSocialInsuranceClassLevel",
          },
          {
            name: "员工社保注册审批",
            eName: "Social security registration",
            active: false,
            subOption: false,
            index: "5-12-2",
            path: "/module/EmployeeWagestoGOSIAppliction1",
          },
          {
            name: "员工社保变更审批",
            eName: "Social security changes",
            active: false,
            subOption: false,
            index: "5-12-3",
            path: "/module/EmployeeWagestoGOSIAppliction2",
          },

          {
            name: "员工社保信息管理",
            eName: "Employee social security information management",
            active: false,
            subOption: false,
            index: "5-12-6",
            path: "/module/EmployeeSocialInsurance",
          },
          // {
          //   name: "GOSI费用分割审批",
          //   active: false,
          //   subOption: true,
          //   arrow: false,
          //   index: "5-12-7",
          //   path: "/pages/WSYW/IndustrialInsurance.aspx",
          // },
          {
            name: "GOSI费用分割审批",
            eName: "GOSI Cost",
            active: false,
            subOption: false,

            index: "5-12-8",
            path: "/module/GOSICost",
          },
          // {
          //   name: "GOSI预警",
          //   active: false,
          //   subOption: false,

          //   index: "5-12-9",
          //   path: "/pages/WSYW/WarningGOSI.aspx",
          // },
          {
            name: "GOSI工伤报告",
            eName: "GOSI work injury report",
            active: false,
            subOption: false,
            index: "5-12-10",
            path: "/module/PersonalInjurySiteGOSIInformationApplication",
          },
          {
            name: "GOSI理赔台账",
            eName: "GOSI Claims ledger",
            active: false,
            subOption: false,
            index: "5-12-11",
            path: "/module/PersonalInjurySiteGOSIInformationAccounting",
          },
        ],
      },
      {
        name: "护照管理",
        eName: "Passport management",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-13",
        children: [
          {
            name: "护照信息更新审批",
            eName: "Passport information update",
            active: false,
            subOption: false,

            index: "5-13-1",
            path: "/module/updatePassport",
          },
          {
            name: "护照信息管理",
            eName: "Passport information management",
            active: false,
            subOption: false,

            index: "5-13-2",
            path: "/module/passport",
          },
        ],
      },
      {
        name: "当地驾照",
        eName: "Local driver's license",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-14",
        children: [
          {
            name: "当地驾照新办审批",
            eName: "New driver's license application",
            active: false,
            subOption: false,
            index: "5-14-1",
            path: "/module/issueNewDrivingLicense",
          },
          {
            name: "当地驾照延期审批",
            eName: "Driver's license extension",
            active: false,
            subOption: false,

            index: "5-14-2",
            path: "/module/renewDrivingLicenseApplication",
          },
          {
            name: "驾照信息管理",
            eName: "Driver's license information management",
            active: false,
            subOption: false,

            index: "5-14-3",
            path: "/module/drivingLicense",
          },
        ],
      },
      {
        name: "费用管理",
        eName: "Cost Management",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-15",
        children: [
          {
            name: "外事费用标准",
            eName: "Foreign Affairs Expense Standards",
            active: false,
            subOption: false,

            index: "5-15-1",
            path: "/module/foreignAffairsCost",
          },
          {
            name: "外事付费明细",
            eName: "Details of Foreign Affairs Payment",
            active: false,
            subOption: false,

            index: "5-15-2",
            path: "/module/foreignAffairsPayment",
          },
          {
            name: "外事付费明细汇总",
            eName: "Summary of Foreign Affairs Payment Details",
            active: false,
            subOption: false,

            index: "5-15-3",
            path: "/module/foreignAffairsPaymentSummaryApplicationDetail",
          },
          {
            name: "外事付费审批",
            eName: "Approval of Foreign Affairs Payment",
            active: false,
            subOption: false,

            index: "5-15-4",
            path: "/module/foreignAffairsPaymentSummaryApplication",
          },
        ],
      },
      {
        name: "外事业务台账",
        eName: "Foreign Affairs Business Ledger",
        active: false,
        subOption: false,

        index: "5-16",
        path: "/module/foreignAffairsAccounting",
      },
      {
        name: "外事报表",
        eName: "Foreign Affairs Report",
        active: false,
        subOption: true,
        arrow: false,
        index: "5-17",
        children: [
          {
            name: "外事业务办理量",
            eName: "Foreign affairs processing volume",
            active: false,
            subOption: false,
            index: "5-17-1",
            path: "/module/handlingForeignAffairs",
          },
          {
            name: "外事业务统计分析",
            eName: "Statistical analysis of foreign affairs business",
            active: false,
            subOption: false,

            index: "5-17-2",
          },
        ],
      },
    ],
  },
  {
    name: "航空票务",
    eName: "Air Ticket",
    icon: "fa ion-android-plane",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "6",
    children: [
      {
        name: "票代管理",
        eName: "Agent",
        active: false,
        subOption: true,
        arrow: false,
        index: "6-1",
        children: [
          {
            name: "票代引入审批",
            eName: "Intro Application",
            active: false,
            subOption: false,
            index: "6-1-1",
            path: "/module/NewTicketingAgentApplication",
          },
          {
            name: "票代资源库管理",
            eName: "Resource",
            active: false,
            subOption: false,
            index: "6-1-2",
            path: "/module/ticketingAgent",
          },
        ],
      },
      {
        name: "票务管理",
        eName: "Ticket",
        active: false,
        subOption: true,
        arrow: false,
        index: "6-2",
        children: [
          {
            name: "机票请购审批",
            eName: "Purchase Application",
            active: false,
            subOption: false,
            index: "6-2-1",
            path: "/module/ticketPurchase",
          },
          {
            name: "机票变更审批",
            eName: "Reschedule Application",
            active: false,
            subOption: false,
            index: "6-2-2",
            path: "/module/ticketChange",
          },
          {
            name: "机票订购管理",
            eName: "Booking",
            active: false,
            subOption: false,
            index: "6-2-3",
            path: "/module/ticketBooking",
          },
          {
            name: "接送站信息",
            eName: "Pickup & Dropoff",
            active: false,
            subOption: false,
            index: "6-2-4",
            path: "/module/transferStation",
          },
          {
            name: "机票信息台账",
            eName: "Ticket Record",
            active: false,
            subOption: false,
            index: "6-2-5",
            path: "/module/ticketAirfare",
          },
          {
            name: "机票付费管理",
            eName: "Payment",
            active: false,
            subOption: true,
            arrow: false,
            index: "6-2-6",
            children: [
              {
                name: "机票费用明细",
                eName: "Fare Detail",
                active: false,
                subOption: false,
                index: "6-2-6-1",
                path: "/module/ticketFareDetail",
              },
              {
                name: "费用明细汇总",
                eName: "Summary",
                active: false,
                subOption: true,
                arrow: false,
                index: "6-2-6-2",
                children: [
                  {
                    name: "分割单审批",
                    eName: "Split Bill app",
                    active: false,
                    subOption: false,
                    index: "6-2-6-2-1",
                    path: "/module/TicketFareSummaryApplicationDetail",
                  },
                  {
                    name: "付款通知单审批",
                    eName: "Payment Bill app",
                    active: false,
                    subOption: false,
                    index: "6-2-6-2-2",
                    path: "/module/ticketFarePaymentSummaryApplication",
                  },
                ],
              },

              {
                name: "费用汇总",
                eName: "Bill",
                active: false,
                subOption: true,
                arrow: false,
                index: "6-2-6-3",
                children: [
                  {
                    name: "分割单汇总",
                    eName: "Split Bill",
                    active: false,
                    subOption: false,
                    index: "6-2-6-3-1",
                    path: "/module/ticketFareSummaryApplication",
                  },
                  {
                    name: "付款通知单汇总",
                    eName: "Payment Bill",
                    active: false,
                    subOption: false,
                    index: "6-2-6-3-2",
                    path: "/module/ticketFarePaymentSummary",
                  },
                ],
              },
            ],
          },
          {
            name: "机票费用分割审批",
            eName: "Cost Split Application",
            active: false,
            subOption: false,
            index: "6-2-7",
            path: "/module/splitAirfareCosts",
          },
        ],
      },
      {
        name: "综合管理",
        eName: "Comprehensive",
        active: false,
        subOption: true,
        arrow: false,
        index: "6-3",
        children: [
          {
            name: "飞行路线管理",
            eName: "Airline",
            active: false,
            subOption: false,
            index: "6-3-1",
            path: "/module/flightPath",
          },
          {
            name: "目的地国家管理",
            eName: "Country & Region",
            active: false,
            subOption: false,
            index: "6-3-2",
            path: "/module/NARManagement",
          },
          {
            name: "目的地城市管理",
            eName: "City",
            active: false,
            subOption: false,
            index: "6-3-3",
            path: "/module/urbanManagement",
          },
        ],
      },
      {
        name: "票务报表",
        eName: "Report",
        active: false,
        subOption: true,
        arrow: false,
        index: "6-4",
        children: [
          {
            name: "票务统计分析",
            eName: "Stats Analysis",
            active: false,
            subOption: false,
            index: "6-4-1",
            path: "/module/ticketStatisticsAnalysis",
          },
          {
            name: "票价统计分析",
            eName: "Fare",
            active: false,
            subOption: true,
            arrow: false,
            index: "6-4-2",
            children: [
              {
                name: "票价分析1",
                eName: "Analysis 1",
                active: false,
                subOption: false,
                index: "6-4-2-1",
                path: "/module/ticketFareStats1",
              },
              {
                name: "票价分析2",
                eName: "Analysis 2",
                active: false,
                subOption: false,
                index: "6-4-2-2",
                path: "/module/ticketFareStats2",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "公共安全",
    eName: "Public Safety",
    icon: "fa fa-medkit",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "7",
    children: [
      {
        name: "境外公共安全培训",
        eName: "Safety Training",
        active: false,
        subOption: true,
        arrow: false,
        index: "7-1",
        children: [
          {
            name: "公共安全培训审批",
            eName: "Request Application",
            active: false,
            subOption: false,
            index: "7-1-1",
            path: "/module/overseasPublicSafetyTraining",
          },
          {
            name: "公共安全培训信息管理",
            eName: "Safety Training",
            active: false,
            subOption: false,
            index: "7-1-2",
            path: "/module/PublicSafetyTraining",
          },

          {
            name: "公共安全培训台账",
            eName: "Training Record",
            active: false,
            subOption: false,
            index: "7-1-4",
            path: "/module/overseasPublicSafetyTrainingLedger",
          },
          {
            name: "境外公共安全培训费用分割审批",
            eName: "Cost",
            active: false,
            subOption: false,
            index: "7-1-5",
            path: "/module/overseasPublicSafetyTrainingCost",
          },
        ],
      },
      {
        name: "人身意外伤害保险&SOS",
        eName: "PA & SOS",
        active: false,
        subOption: true,
        arrow: false,
        index: "7-2",
        children: [
          {
            name: "境外人保信息管理",
            eName: "Overseas Insurance",
            active: false,
            subOption: false,
            index: "7-2-1",
            path: "/module/employeePersonalAccidentInsurance",
          },
          {
            name: "出险记录",
            eName: "Claim Record",
            active: false,
            subOption: false,
            index: "7-2-2",
            path: "/module/employeePersonalAccidentInsuranceClaimRecords",
          },
          {
            name: "人身意外伤害保险费用分割审批",
            eName: "Insurance Cost",
            active: false,
            subOption: false,
            index: "7-2-3",
            path: "/module/employeePersonalAccidentInsuranceCost",
          },
        ],
      },
      {
        name: "员工健康管理",
        eName: "Employee Health",
        active: false,
        subOption: true,
        arrow: false,
        index: "7-3",
        children: [
          {
            name: "员工常规体检指数标准",
            eName: "Physical Exam Standard",
            active: false,
            subOption: false,
            index: "7-3-0",
            path: "/module/EmployeePhysicalExamMetrics",
          },
          {
            name: "员工常规体检记录",
            eName: "Physical Exam Record",
            active: false,
            subOption: false,
            index: "7-3-1",
            path: "/module/EmployeePhysicalExamination",
          },
          {
            name: "员工健康风险评估(境外)",
            eName: "Risk Assessment",
            active: false,
            subOption: false,
            index: "7-3-2",
            path: "/module/EmployeeHealthRiskAssessment",
          },
          {
            name: "员工健康档案",
            eName: "Employee Document",
            active: false,
            subOption: false,
            index: "7-3-3",
            path: "/module/EmployeeHealthInformationRecord",
          },
          {
            name: "健康指标异常人员台账",
            eName: "Abnormal Indicator",
            active: false,
            subOption: false,
            index: "7-3-4",
          },
          {
            name: "风险评估到期预警",
            eName: "Warning",
            active: false,
            subOption: false,
            index: "7-3-5",
          },
        ],
      },
    ],
  },

  {
    name: "员工劳保",
    eName: "PPE of Employee",
    icon: "fa fa-shield",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "8",
    children: [
      {
        name: "劳动防护用品年度计划审批",
        eName: "PPE Plan Applicaction",
        active: false,
        subOption: false,
        index: "8-1",
        path: "/module/auxiliaryMaterial",
      },
      {
        name: "劳动防护用品申领审批",
        eName: "PPE Request Application",
        active: false,
        subOption: false,
        index: "8-2",
        path: "/module/PPERequestApplication",
      },
      {
        name: "劳保发放台账",
        eName: "PPE Issuance Log",
        active: false,
        subOption: false,
        index: "8-3",
        path: "/module/PPERequestAccounting",
      },
      {
        name: "员工劳保信息档案",
        eName: "Employee PPE Record",
        active: false,
        subOption: false,
        index: "8-4",
        path: "/module/userPPE",
      },
      {
        name: "安全帽款式",
        eName: "Helmet Type",
        active: false,
        subOption: false,
        index: "8-5",
        path: "/module/userPPEDic",
      },
    ],
  },
  {
    name: "成本费用",
    eName: "Cost",
    icon: "fa ion-social-yen",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "9",
    children: [
      {
        name: "其他付费",
        eName: "Others",
        active: false,
        subOption: false,
        index: "9-1",
        path: "/module/muqeemSystemApplication",
      },
      {
        name: "成本统计",
        eName: "Cost Stats",
        active: false,
        subOption: false,
        index: "9-2",
        path: "/module/costChilden1",
      },
      // {
      //   name: "费用项目管理",
      //   eName: "Cost Item",
      //   active: false,
      //   subOption: false,
      //   index: "9-3",
      //   path: "/module/CostCategory",
      // },

      // {
      //   name: "费用归集管理",
      //   eName: "Cost Pooling",
      //   active: false,
      //   subOption: false,
      //   index: "9-4",
      //   path: "/module/costPoolCategory",
      // },
      {
        name: "费用类别",
        eName: "Cost type",
        active: false,
        subOption: true,
        arrow: false,
        index: "9-7",
        children: [
          {
            name: "费用归集",
            eName: "Cost Aggregation",
            active: false,
            subOption: false,
            index: "9-7-1",
            path: "/module/CostAggregation",
          },
          {
            name: "费用大项",
            eName: "Cost Major Category",
            active: false,
            subOption: false,
            index: "9-7-2",
            path: "/module/CostMajorCategory",
          },
          {
            name: "费用子项",
            eName: "Cost Sub Category",
            active: false,
            subOption: false,
            index: "9-7-3",
            path: "/module/CostSubCategory",
          },
          {
            name: "费用细项",
            eName: "Cost Category Detail",
            active: false,
            subOption: false,
            index: "9-7-4",
            path: "/module/CostCategoryDetail",
          },
        ],
      },
      {
        name: "费用汇总统计明细",
        eName: "cost Stats Detail",
        active: false,
        subOption: false,
        index: "9-6",
        path: "/module/costStatsDetail",
      },
      {
        name: "费用汇总统计",
        eName: "Cost Summary Stats",
        active: false,
        subOption: false,
        index: "9-5",
        path: "/module/costStats",
      },
    ],
  },

  {
    name: "员工自助",
    eName: "Employee Self-Service",
    icon: "fa fa-user",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "10",
    children: [
      {
        name: "收入证明",
        eName: "Income Certificate",
        active: false,
        subOption: false,
        index: "10-1",
        path: "/module/incomeCertificate",
      },
      {
        name: "工作证明",
        eName: "Proof of Employment",
        active: false,
        subOption: false,
        index: "10-2",
        path: "/module/proofEmployment",
      },
      {
        name: "离职证明",
        eName: "Certificate of Employment",
        active: false,
        subOption: false,
        index: "10-3",
        path: "/module/employmentSeparation",
      },
      {
        name: "操作帮助",
        eName: "Help",
        active: false,
        subOption: false,
        index: "10-4",
        path: "/module/operation",
      },
      {
        name: "文件下载",
        eName: "Download",
        active: false,
        subOption: false,
        index: "10-5",
        path: "/pages/HELP/FileDownload.aspx",
      },
    ],
  },
  {
    name: "消息管理",
    eName: "Message",
    icon: "fa ion-chatbox-working",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "11",
    children: [
      {
        name: "费用清缴",
        eName: "Fee Settlement",
        active: false,
        subOption: true,
        arrow: false,
        index: "11-1",
        children: [
          {
            name: "员工社保两金及个税清缴信息",
            eName: "Settlement Info",
            active: false,
            subOption: false,
            index: "11-1-1",
            path: "/module/EmployeeSettlementInfo",
          },
          {
            name: "员工社保两金及个税清缴通知",
            eName: "Settlement Notification",
            active: false,
            subOption: false,
            index: "11-1-2",
            path: "/module/taxClearAll",
          },
        ],
      },
      {
        name: "通知订阅",
        eName: "Notification Subscribe",
        active: false,
        subOption: false,
        index: "11-2",
        path: "/module/systemRoleMessageSubscription",
      },
      {
        name: "站内信",
        eName: "In-Site Message",
        active: false,
        subOption: false,
        index: "11-3",
        path: "/module/mail",
      },
      {
        name: "网站公告",
        eName: "News",
        active: false,
        subOption: false,
        index: "11-4",
        path: "/module/news",
      },
    ],
  },

  {
    name: "系统设置",
    eName: "System Setting",
    icon: "fa ion-gear-b",
    active: false,
    subOption: true,
    arrow: false,
    height2: 0,
    height3: 0,
    height4: 0,
    index: "12",
    children: [
      {
        name: "系统模块",
        eName: "System Module",
        active: false,
        subOption: false,
        path: "/module/system",
        index: "12-1",
      },
      {
        name: "角色管理",
        eName: "Role",
        active: false,
        subOption: false,
        path: "/module/roles",
        index: "12-2",
      },
      {
        name: "权限配置",
        eName: "Permission",
        active: false,
        subOption: false,
        path: "/module/rights",
        index: "12-3",
      },
      {
        name: "授权码表",
        eName: "Authorization Code",
        active: false,
        subOption: false,
        index: "12-4",
        path: "/pages/User/AuthorizationCode.aspx",
      },
      {
        name: "账号管理",
        eName: "Account",
        active: false,
        subOption: false,
        index: "12-5",
        path: "/pages/SYSTEM/AdminList.aspx",
      },

      {
        name: "修改密码",
        eName: "Change Password",
        active: false,
        subOption: false,
        index: "12-6",
        path: "/module/setPassword",
      },
      {
        name: "系统日志",
        eName: "System Log",
        active: false,
        subOption: false,
        index: "12-7",
        path: "/module/journal",
      },
      {
        name: "退出系统",
        eName: "Logout",
        active: false,
        subOption: false,
        index: "12-8",
        path: "/signin",
      },
    ],
  },
  {
    name: "历史版本模块",
    eName: "Historical version module",
    icon: "fa fa-history",
    active: false,
    subOption: true,
    arrow: false,
    index: "14",
    children: [
      {
        name: "组织关系（薪资汇总）",
        eName: "Org. Structure（Salary）",
        active: false,
        subOption: false,
        index: "14-1",
        path: "/pages/User/ProjectCompanyRelation.aspx",
      },
    ],
  },

  {
    name: "问题反馈",
    eName: "Feedback",
    icon: "fa ion-compose",
    active: false,
    subOption: false,
    path: "/module/feedbacks",
    index: "13",
  },
];

//计算索引
export const getIndicesByHref = (data, targetPath) => {
  let result = [];

  function traverse(items, path) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.path === targetPath) {
        result = [...path, i];
        return;
      }
      if (item.children) {
        traverse(item.children, [...path, i]);
      }
    }
  }

  traverse(data, []);
  return result;
};
